import { render, staticRenderFns } from "./ProjectDesignProfile.vue?vue&type=template&id=400f5c06"
import script from "./ProjectDesignProfile.vue?vue&type=script&lang=js"
export * from "./ProjectDesignProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports